import IntegrationGuide from "./IntegrationGuide"

export default IntegrationGuide
